module.exports = __webpack_public_path__ + "static/media/buisness-backg-2.c6c73736.png";